import type { RegisteredDistanceType } from '../types';

function isReceipt(distance: RegisteredDistanceType | null) {
  return Boolean(distance?.order);
}

export { isReceipt };
